import React, {useEffect} from "react";
import "./TheVoid.css";
import theVoidCat from "../../images/the_void_cat.png";
import anime from "animejs";

import { motion } from "framer-motion";

export default function TheNothingProject(){
    useEffect(() => {
        var canvasHeight, canvasWidth, animations = [], bgColor = "#FFBE53";
        var canvas = document.getElementById("theNothingProjectaCanvas");
        var ctx = canvas.getContext("2d");

        const colorPicker = (() => {
            var colors = ["#FFBE53", "#A4F3E6", "#FFBE53", "#2980B9", "#282741",
                             "#EBFFFD", "#474B4E", "#E880EB", "#E6D690", "#57A639", 
                             "#F8F32B", "#FF6138", "#242526"];
            var index = 0;
            function next() {
                index = (index++ < colors.length-1) ? index : 0;
                return colors[index];
            }
            function current() {
                return colors[index]
            }

            return {
                next: next,
                current: current
            }
        })();
        
        const handleEvent = (e) => {
            if (e.touches) { 
                e.preventDefault();
                e = e.touches[0];
            }
            var currentColor = colorPicker.current();
            var nextColor = colorPicker.next();
            var targetR = calcPageFillRadius(e.pageX, e.pageY);
            var rippleSize = Math.min(200, (canvasWidth * .4));
            var minCoverDuration = 750;
            var particles = [];
            
            var pageFill = new Circle({
                x: e.pageX,
                y: e.pageY,
                r: 0,
                fill: nextColor
            });
            var fillAnimation = anime({
                targets: pageFill,
                r: targetR,
                duration:  Math.max(targetR / 2 , minCoverDuration ),
                easing: "easeOutQuart",
                complete: function(){
                    bgColor = pageFill.fill;
                    removeAnimation(fillAnimation);
                }
            });
            
            for (var i=0; i<32; i++) {
                var particle = new Circle({
                    x: e.pageX,
                    y: e.pageY,
                    fill: currentColor,
                    r: anime.random(24, 48)
                })
                particles.push(particle);
            }
            
            var particlesAnimation = anime({
                targets: particles,
                x: function(particle){
                    return particle.x + anime.random(rippleSize, -rippleSize);
                },
                y: function(particle){
                    return particle.y + anime.random(rippleSize * 1.15, -rippleSize * 1.15);
                },
                r: 0,
                easing: "easeOutExpo",
                duration: anime.random(1500,1300),
                complete: removeAnimation
            });
            animations.push(fillAnimation, particlesAnimation);
        }

        function removeAnimation(animation) {
            var index = animations.indexOf(animation);
            if (index > -1) animations.splice(index, 1);
        }
        
        function calcPageFillRadius(x, y) {
            var l = Math.max(x - 0, canvasWidth - x);
            var h = Math.max(y - 0, canvasHeight - y);
            return Math.sqrt(Math.pow(l, 2) + Math.pow(h, 2));
        }
        
        function extend(a, b){
            for(var key in b) {
                if(b.hasOwnProperty(key)) {
                    a[key] = b[key];
                }
            }
            return a;
        }
        
        var Circle = function(opts) {
            extend(this, opts);
        }
        
        Circle.prototype.draw = function() {
            ctx.globalAlpha = this.opacity || 1;
            ctx.beginPath();
            ctx.arc(this.x, this.y, this.r, 0, 2 * Math.PI, false);
            if (this.stroke) {
                ctx.strokeStyle = this.stroke.color;
                ctx.lineWidth = this.stroke.width;
                ctx.stroke();
            }
            if (this.fill) {
                ctx.fillStyle = this.fill;
                ctx.fill();
            }
            ctx.closePath();
            ctx.globalAlpha = 1;
        }
        
        var animate = anime({
            duration: Infinity,
            update: function() {
                ctx.fillStyle = bgColor;
                ctx.fillRect(0, 0, canvasWidth, canvasHeight);
                animations.forEach(function(anim) {
                    anim.animatables.forEach(function(animatable) {
                        animatable.target.draw();
                    });
                });
            }
        });
        
        const resizeCanvas = () => {
            canvasWidth = window.innerWidth;
            canvasHeight = window.innerHeight;
            canvas.width = canvasWidth * devicePixelRatio;
            canvas.height = canvasHeight * devicePixelRatio;
            ctx.scale(devicePixelRatio, devicePixelRatio);
        };
                
        const handleInactiveUser = () => {
            var inactive = setTimeout(function(){
                fauxClick(canvasWidth/2, canvasHeight/2);
            }, 1000);
            
            function clearInactiveTimeout() {
                clearTimeout(inactive);
                document.getElementsByTagName('main')[0].removeEventListener("mousedown", clearInactiveTimeout);
                document.getElementsByTagName('main')[0].removeEventListener("touchstart", clearInactiveTimeout);
            }
            
            document.getElementsByTagName('main')[0].addEventListener("mousedown", clearInactiveTimeout);
            document.getElementsByTagName('main')[0].addEventListener("touchstart", clearInactiveTimeout);
        }
        
        const startFauxClicking = () => {
            setTimeout(function(){
                fauxClick(anime.random( canvasWidth * .2, canvasWidth * .8), anime.random(canvasHeight * .2, canvasHeight * .8));
                startFauxClicking();
            }, anime.random(200, 900));
        }
        
        const fauxClick = (x, y) => {
            var fauxClick = new Event("mousedown");
            fauxClick.pageX = x;
            fauxClick.pageY = y;
            document.getElementsByTagName('main')[0].dispatchEvent(fauxClick);
        }

        (function init() {
            resizeCanvas();
            if (window.CP) {
                // CodePen's loop detection was causin' problems
                // and I have no idea why, so...
                window.CP.PenTimer.MAX_TIME_IN_LOOP_WO_EXIT = 6000; 
            }
            window.addEventListener("resize", resizeCanvas);

            document.getElementsByTagName('main')[0].addEventListener("touchstart", handleEvent);
            document.getElementsByTagName('main')[0].addEventListener("mousedown", handleEvent);

            if (!!window.location.pathname.match(/fullcpgrid/)) {
                startFauxClicking();
            }
            handleInactiveUser();
        })();
    }, [])

    const takeMeHome = () => {
        setTimeout(()=>{
            window.location = "/home";
        }, 450);
    }

    return (
        <main>
            <div className="the_void_message">

                <img src={theVoidCat} alt="404"/>
                <h3>Oh Snap! You have entered the Void</h3>
                <h5>Even the EmoAI couldn't figure out how you feel!</h5>

                <br/>
                <motion.button 
                    type="button"
                    className="button the-void-button"
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.8 }}
                    onClick={()=>{
                        takeMeHome();
                    }}
                    onTouchEnd={()=>{
                        takeMeHome();
                    }}
                >Take me home
                </motion.button>
                
            </div>
            <canvas id="theNothingProjectaCanvas" className="the_nothing_canvas"></canvas>
        </main>
    );
}
